<template>
  <div class="container" style="text-align: center;padding: 20px 0 0 0;margin: 0px;">
    <div class="welcome">
      <b>
        <span> 欢迎来到西安伟思特</span>
        <br><br/>
        <span style="color: black">
					{{ admin.name }}
				</span>
      </b>
    </div>
    <br/>
    <h5 style="font-size: 26px">
      <span style="color: grey; font-size: 22px">您当前的角色是：</span>
      {{ admin.type == 0 ? "超级管理员" : admin.type == 1 ? "负责人" : "工作人员" }}
    </h5>
    <DateUtils></DateUtils>
    <h5 style="font-size: 26px">
      <span style="color: grey; font-size: 25px">
        <template v-if="time.hour >= 8 && time.hour < 12">
          早上好呀，新的一天开始了，加油哦！
        </template>
        <template v-if="time.hour >= 12 && time.hour < 14">
          中午好！辛苦了一上午，午餐时间好好休息一下吧。
        </template>
        <template v-if="time.hour >= 14 && time.hour < 17">
          下午好！希望上午的工作都顺利完成了，下午继续努力哦！
        </template>
        <template v-if="time.hour >= 17 && time.hour < 18">
          下班时间快到了，今天的努力值得点赞，明天继续加油！
        </template>
        <template v-if="time.hour >= 18 && time.hour < 19">
          下班啦，明天见!
        </template>
        <template v-if="time.hour >= 19 && time.hour < 24">
          晚上好，还在加班吗？注意劳逸结合哦。
        </template>
      </span>
    </h5>
  </div>
</template>

<script>
import DateUtils from "./DateUtils";

export default {
  name: "Home",
  components: {
    DateUtils
  },
  data() {
    return {
      admin: {},
      time: {}
    };
  },
  methods: {
    init() {
      this.admin = JSON.parse(sessionStorage.getItem("adminInfo"));
    },
  },
  mounted() {
    this.init();
    this.time.hour = new Date().getHours()
  },
};
</script>

<style scoped>

.welcome {
  font-size: 30px;
  color: grey;
  position: relative;
  z-index: 1;
}
</style>